import { useQuery } from '@tanstack/react-query'
import { outreachApi, outreachMessagesQueryKey } from '../api'

/**
 * The founder's sequence.
 *
 * `backfillArms` asks the server to generate any missing versions. ONLY the
 * review dialog sets it: the outreach page calls this on every render, and
 * generating there would make an arm sendable off the back of a page view,
 * without the founder ever having been shown the versions.
 */
export function useOutreachMessagesQuery(startupId: string, backfillArms = false, enabled = true) {
  return useQuery({
    queryKey: outreachMessagesQueryKey(startupId, backfillArms),
    queryFn: () => outreachApi.getMessages(startupId, backfillArms),
    // The review dialog keeps its bodies MOUNTED while closed (their refs feed
    // the shared approve handler), so a generating query would otherwise fire
    // on every render of the outreach page — generation without the founder
    // having opened anything, which is the case this flag exists to prevent.
    enabled,
  })
}
